import { Button, Card, EmptyState, PageHead } from "@nabble/ui";
import { PoliciesSkeleton } from "./PoliciesSkeleton";
import { PolicyFieldRow } from "./PolicyFieldRow";
import { SECTIONS } from "./policySections";
import { digitsOnly } from "./policyValues";
import { UnsavedChangesBar } from "./UnsavedChangesBar";
import { usePolicies } from "./usePolicies";

export default function AdminPoliciesPage(): React.JSX.Element {
  const form = usePolicies();
  const { values, defaults, saved } = form;
  const head = <PageHead titleHidden title="Policies" />;

  if (form.loadError) {
    return (
      <div>
        {head}
        <div className="nb-card">
          <EmptyState
            icon="alertCircle"
            title="We couldn't load the policies"
            description={form.loadError}
            action={<Button label="Try again" variant="secondary" icon="refresh" onClick={form.load} />}
          />
        </div>
      </div>
    );
  }

  if (!values || !defaults || !saved) {
    return (
      <div>
        {head}
        <PoliciesSkeleton />
      </div>
    );
  }

  return (
    <div>
      {head}
      <form
        className="nb-stack-lg"
        style={{ maxWidth: 960 }}
        onSubmit={(e) => {
          e.preventDefault();
          void form.save();
        }}
        noValidate
      >
        {SECTIONS.map((section) => (
          <Card key={section.id} title={section.title} description={section.description} padded={false}>
            {section.fields.map((f) => (
              <PolicyFieldRow
                key={f.key}
                field={f}
                value={values[f.key]}
                defaultValue={defaults[f.key]}
                invalid={form.invalid[f.key]}
                range={form.ranges[f.key]}
                onChange={(typed) => form.setValue(f.key, digitsOnly(typed))}
              />
            ))}
          </Card>
        ))}

        {form.dirtyKeys.length > 0 ? (
          <UnsavedChangesBar count={form.dirtyKeys.length} saving={form.saving} blocked={Object.keys(form.invalid).length > 0} onDiscard={form.discard} />
        ) : null}
      </form>
    </div>
  );
}
